import { all, call, delay, fork, put, takeLatest } from "redux-saga/effects";
import * as VinWonderTagGroupService from "../services/vinwonderTagGroupService";
import * as Types from '../constants/Types';
import * as VinwonderTagGroupAction from "../actions/vinwonderTagGroupAction";
import * as Func from "../helpers/functions";
import { PATHS, SAGA_DELAY_TIMEOUT, SAGA_DELAY_TIMEOUT_1000 } from "constants/Define";
import i18n from "constants/initLng";
import history from '../helpers/history';
import { vinWonderTagGroupAutoTranslateRequest } from '../actions/autoTranslateAction';

function* getListVinwonderTagGroups() {
    yield takeLatest(Types.VINWONDER_TAGGROUP_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(VinWonderTagGroupService.getVinwonderTagGroups, action.params);
        yield put(VinwonderTagGroupAction.setVinwonderTagGroupListAll({listVinwonderTagGroups: (result?.data?.data?.result || []), totalCount: result?.data?.data?.totalCount || 0, ...action.params}));
    }, errorHandleVinWonderTagGroup(Types.VINWONDER_TAGGROUP_LIST_FAIL)))
}
function* getListSupplierCategories() {
    yield takeLatest(Types.VINWONDER_TAGGROUP_LIST_SUPPLIERS_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(VinWonderTagGroupService.getSupplierCategories, action.params);
        yield put(VinwonderTagGroupAction.setSupplierCategoryList({supplierCategories: (result?.data?.data || [])}));
    }, errorHandleVinWonderTagGroup(Types.VINWONDER_TAGGROUP_LIST_SUPPLIERS_FAIL)))
}


function* getListSkusFollowSupplier() {
    yield takeLatest(Types.VINWONDER_TAGGROUP_LIST_SKU_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(VinWonderTagGroupService.getSkuFollowSupplier, {productType: 7, supplierIds: action.id});
        yield put(VinwonderTagGroupAction.setListSkusFollowSupplier({listSkus: (result?.data?.data || [])}));
    }, errorHandleVinWonderTagGroup(Types.VINWONDER_TAGGROUP_LIST_SKU_FAIL)))
}

function* createVinwonderTagGroup() {
    yield takeLatest(Types.VINWONDER_TAGGROUP_CREATE_ACTION, Func.sagaWrapper(function* (action) {
            const vinwonderTagGroup = action.vinwonderTagGroup;
            const result = yield call(VinWonderTagGroupService.createVinwonderTagGroup, vinwonderTagGroup);
            yield delay(SAGA_DELAY_TIMEOUT_1000)
            Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), vinwonderTagGroup.code);
            history.push(PATHS.TAG_GROUP_VW.LIST.path);
            history.go();
        }, errorHandleVinWonderTagGroup(Types.VINWONDER_TAGGROUP_CREATE_FAIL)))
}

function* updateVinwonderTagGroup() {
    yield takeLatest(Types.VINWONDER_TAGGROUP_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
            const vinwonderTagGroup = action.vinwonderTagGroup;
            const result = yield call(VinWonderTagGroupService.updateVinwonderTagGroup, vinwonderTagGroup);
            yield delay(SAGA_DELAY_TIMEOUT_1000)
            Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), vinwonderTagGroup.code);
            if (vinwonderTagGroup.targetLanguage && vinwonderTagGroup.targetLanguage.length > 0) {
                yield put(vinWonderTagGroupAutoTranslateRequest({
                    sourceId: vinwonderTagGroup.id,
                    sourceLanguage: 'vi-VN',
                    targetLanguages: vinwonderTagGroup.targetLanguage,
                    callbacks: action.callbacks
                }));
            } else if (action.callbacks?.onSuccess) {
                yield action.callbacks.onSuccess();
            } else {
                history.push(PATHS.TAG_GROUP_VW.LIST.path);
                history.go();
            }
        }, errorHandleVinWonderTagGroup(Types.VINWONDER_TAGGROUP_UPDATE_FAIL)))
}

function* getVinWonderTagGroupDetail() {
    yield takeLatest(Types.VINWONDER_TAGGROUP_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(VinWonderTagGroupService.getDetailVinwonderTagGroup, action.id);
        yield put(VinwonderTagGroupAction.setVinwonderTagGroupDetail(result));
    }, errorHandleVinWonderTagGroup(Types.VINWONDER_TAGGROUP_DETAIL_FAIL)))
}

function* deleteVinWonderTagGroup() {
    yield takeLatest(Types.VINWONDER_TAGGROUP_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(VinWonderTagGroupService.deleteVinWonderTagGroup, action.vinwonderTagGroup.id);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.removeSuccess')}`, description: `${i18n.t('item.supplierCategory.title')} "${action.vinwonderTagGroup.code}"` });
        yield delay(SAGA_DELAY_TIMEOUT);
        history.push(PATHS.TAG_GROUP_VW.LIST.path);
        history.go();
    }, errorHandleVinWonderTagGroup(Types.SUPPLIER_CATEGORY_FAIL)))
}

function* dragToOrder() {
    yield takeLatest(Types.VINWONDER_TAGGROUP_DRAG_TO_ORDER_ACTION, Func.sagaWrapper(function* (action) {
        yield call(VinWonderTagGroupService.dragToOrderTag, action.vinwonderTagGroup);
        yield put(VinwonderTagGroupAction.getVinwonderTagGroupListAll({
            supplierId: action.vinwonderTagGroup.supplierId,
            siteType: action.vinwonderTagGroup.siteType,
        }));
    }, errorHandleVinWonderTagGroup(Types.VINWONDER_TAGGROUP_DRAG_TO_ORDER_FAIL)))
}

function* updateDefaultTag() {
    yield takeLatest(Types.VINWONDER_TAGGROUP_UPDATE_DEFAULT_TAG_IN_SUPPLIER_ACTION, Func.sagaWrapper(function* (action) {
        yield call(VinWonderTagGroupService.updateDefaultTag, action.vinwonderTagGroup);
        yield put(VinwonderTagGroupAction.getVinwonderTagGroupListAll({
            supplierId: action.vinwonderTagGroup.supplierId,
            siteType: action.vinwonderTagGroup.siteType,
        }));
    }, errorHandleVinWonderTagGroup(Types.VINWONDER_TAGGROUP_UPDATE_DEFAULT_TAG_IN_SUPPLIER_FAIL)))
}

// TRANSLATE
function* createVinwonderTagGroupTranslate() {
    yield takeLatest(Types.VINWONDER_TAGGROUP_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(VinWonderTagGroupService.createVinwonderTagGroupTranslate, action.vinwonderTagGroup);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.vinwonderTagGroup.translate.languageName);
        yield put({ type: Types.VINWONDER_TAGGROUP_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.VINWONDER_TAGGROUP_DETAIL_ACTION, id: action.vinwonderTagGroup.id });
    }, errorHandleVinWonderTagGroup(Types.VINWONDER_TAGGROUP_UPDATE_FAIL)))
}

function* updateVinwonderTagGroupTranslate() {
    yield takeLatest(Types.VINWONDER_TAGGROUP_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(VinWonderTagGroupService.updateVinwonderTagGroupTranslate, action.vinwonderTagGroup);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.vinwonderTagGroup.translate.languageName);
        yield put({ type: Types.VINWONDER_TAGGROUP_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.VINWONDER_TAGGROUP_DETAIL_ACTION, id: action.vinwonderTagGroup.id });
    }, errorHandleVinWonderTagGroup(Types.VINWONDER_TAGGROUP_UPDATE_FAIL)))
}

function* deleteVinwonderTagGroupTranslate() {
    yield takeLatest(Types.VINWONDER_TAGGROUP_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(VinWonderTagGroupService.deleteVinwonderTagGroupTranslate, action.vinwonderTagGroup.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.vinwonderTagGroup.translate.languageName);
        yield put({ type: Types.VINWONDER_TAGGROUP_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.VINWONDER_TAGGROUP_DETAIL_ACTION, id: action.vinwonderTagGroup.id });
    }, errorHandleVinWonderTagGroup(Types.VINWONDER_TAGGROUP_UPDATE_FAIL)))
}

function errorHandleVinWonderTagGroup(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'vinWonderTagGroup');
}

export function* vinwonderTagGroupSaga() {
    yield all([
        fork(getListSupplierCategories),
        fork(getListSkusFollowSupplier),
        fork(createVinwonderTagGroup),
        fork(getVinWonderTagGroupDetail),
        fork(updateVinwonderTagGroup),
        fork(deleteVinWonderTagGroup),
        fork(getListVinwonderTagGroups),
        fork(dragToOrder),
        fork(updateDefaultTag),
        fork(createVinwonderTagGroupTranslate),
        fork(updateVinwonderTagGroupTranslate),
        fork(deleteVinwonderTagGroupTranslate),
    ])
}
